<template>
    <div class="pt115" id="pt115" v-cloak v-if="pt115Init.productList != null && pt115Init.productList.length > 0">
        <div>
            <div class="itemTitle">
                <!-- ご契約商品一覧 -->
                <h3>{{$t("pt115.labels.title")}}</h3>
            </div>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt115'"/>
        </div>
        <!--カテゴリ名表示-->
        <template  v-if="pt115Init.navList != null && pt115Init.navList.length > 0">
            <!--親カテゴリ名-->
            <h2 v-if="pt115Init.categoryNmOptionFlg == 0">{{pt115Init.navList[0].CATEGORY_NM}}</h2>
            <!--子カテゴリ名-->
            <h2 v-else>{{pt115Init.navList.slice(-1)[0].CATEGORY_NM}}</h2>
        </template>
        <template v-if="showFlg">
            <page-feed
                :isDisplay="isPagingDisplay"
                :isDisplaySort="pt115Init.isDisplaySortFlg"
                :pageFeedData="pageFeedData"
                :orderByType="selectedSortNo"
                :dispPageSizeList="dispPageSizeList"
                :dispSortList="pt115Init.productSortKbnList"
                @search="changeSearch"
                >

                <!--オプション:縦レイアウト -->
                <template slot="TableRender">
                    <div class="section-inner mb16" v-if="pt115Init.productList == null || pt115Init.productList.length == 0">
                        <span  class="text-danger">
                            {{$t('common.labels.messgNoResult')}}
                        </span>
                    </div>
                    <div v-else>
                        <!--カートに追加ボタン-->
                        <input id="nav-search-button" @click="doOrder(pt115Init.productList)" :value="$t('pt115.labels.cartAddBtn')" type="button">
                    </div>
                    <table id="product-list">
                        <tr v-for="(product, index) in pt115Init.productList" :key="index">
                            <th id="itemListImg" :style="pt115Init.itemImgFlg == 0?'display:none;':''">
                                <img style="width:80px; height:80px;" :src="product.IMG_URL1" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">
                            </th>
                            <td>
                                <ul>
                                    <li v-html="product.CATCH_COPY_PRE"></li>
                                    <li>{{product.WEB_ITEM_NM}}</li>
                                    <li v-html="product.CATCH_COPY_SUF"></li>
                                    <li>
                                        <template v-if="product.YOYAKU_ITEM_FLG == 1">
                                            {{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}&nbsp;
                                        </template>
                                        <template v-if="product.HANBAI_FLG == 1">
                                            <template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
                                                <!--在庫数表示、両方表示の場合 -->
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                    {{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}&nbsp;
                                                </template>
                                                <!-- 在庫状態表示、両方表示の場合 -->
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                    <!-- 在庫なし-->
                                                    <template v-if="product.ZAIKO_QTY <= 0">
                                                        <template v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</template>
                                                        <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</template>
                                                    </template>
                                                    <!-- 残りわずか -->
                                                    <template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
                                                        <template v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</template>
                                                        <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</template>
                                                    </template>
                                                    <!-- あり -->
                                                    <template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
                                                        <template v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</template>
                                                        <template v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </li>
                                </ul>
                            </td>
                            <td v-if="!(pt115Init.siteKbn == '4' && !pt115Init.loginKbn)">
                                <template v-if="product.POINT_ITEM_KBN == '0' || product.POINT_ITEM_KBN == '2'">
                                    <!--税込金額 -->
                                    <span v-if="product.ZEI_SET_KBN == '1'">
                                        {{$t('common.labels.price')}}：
                                        <span class="generalPrice">
                                        {{formatPrice(product.TNK_TAX_IN)}}{{$t('common.labels.jpYen')}}
                                        </span>
                                    </span>
                                    <!--税抜金額 -->
                                    <span v-else>
                                        {{$t('common.labels.price')}}：
                                        <span class="generalPrice">
                                        {{formatPrice(product.TNK_TAX_EX)}}{{$t('common.labels.jpYen')}}
                                        </span>
                                    </span>
                                    <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                        <!-- (税込) -->
                                        <template v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</template>
                                        <!-- (税抜) -->
                                        <template v-else>{{$t('common.labels.excludingtax')}}</template>
                                    </template>
                                    <!--ポイント付与 -->
                                    <template v-if="(product.POINT_NUM > 0)">
                                        <br>
                                        <span class="pointNum">
                                            {{formatPrice(product.POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                        </span>
                                    </template>
                                    <!--ポイントキャンペーン対象商品 -->
                                    <template v-if="(product.PROMO_POINT_NUM > 0)">
                                        <br>
                                        <span class="pointGrantCampaign" v-if="(product.POINT_NUM > 0)">
                                            {{$t('common.labels.pointGrantCampaign')}}
                                        </span>
                                        <span class="pointCampaign">
                                            {{formatPrice(product.PROMO_POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                        </span>
                                    </template>
                                </template>
                                <!--ポイント交換商品-->
                                <template v-if="product.POINT_ITEM_KBN == '1' || product.POINT_ITEM_KBN == '2'">
                                    <span class="price">
                                        {{formatPrice(product.POINT_ITEM_NUM)}}{{$t('common.labels.pt')}}
                                    </span>
                                </template>
                            </td>
                            <td>
                                <!-- 数量： -->
                                <div class="itemQty">
                                    <span v-if="pt115Init.puldownFlg != 3">
                                        {{$t('pt110.labels.quantity')}}:
                                        <input-check v-if="product.ZAIKO_QTY > 0" v-model="product.QTY" :value="0" type="text" maxlength="5" size="3"
                                            class="productQty num" />
                                        <input-check v-else v-model="product.QTY" disabled :value="0" type="text" maxlength="5" size="3"
                                            class="productQtyDisabled num" />
                                    </span>
                                    <span v-else>
                                        <!--表示しない（数量0固定）-->
                                        <input-check type="text" class="productQtyDisabled num" maxlength="5" size="3" v-model="product.QTY" :value="0" disabled hidden/>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </table>
                </template>
            </page-feed>
        </template>

        <span id="qty_lbl" style="display:none">
            {{$t('pt115.labels.quantity')}}
        </span>
        <!-- modal confirm area -->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :isButtonCancel="false"
        >
        </alert-confirm>
        <COLOR_SIZE v-if="colorSizeFlg" :data="dataColorSize" @modal-close="colorSizeFlg = false" @set-addr-value="setValue"></COLOR_SIZE>

        <b-modal v-model="showPassModal"
            size="md"
            header-bg-variant="light"
            :title="$t('pt115.labels.accessDialogTitle')" 
            no-close-on-backdrop
            :cancel-title="$t('common.buttons.cancel')"
            :ok-title="$t('pt115.labels.access')"
            @ok="okAction">

            <div v-if="warningMsg" class="col-12 mb-1">
                <span class="text-danger">{{warningMsg}}</span>
            </div>

            <div class="col-8">
                <input-check
                    v-model="pt115ReqModel.secretPassword"
                    type="password" 
                    name="secretPassword"
                    class="form-control form-control w-100 multi" 
                    maxlength="20"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import AlertConfirm from 'components/AlertConfirm';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import PageFeed from "../commonParts/PageFeed";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /*
    * Name of component
    */
    name: "PT115TokuProductListParts",
    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        PageFeed,
        Breadcrumb,
        InputNumber,
        toastr
    },
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        categoryCd:  {
            type: String
        },
        evtChangeCategoryFlg: {
            type: Boolean,
            default: false,
        },
        evtChangeSearchFlg: {
            type: Boolean,
            default: false,
        },
        searchNm : {
            type: String
        },
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isDownload: false,
            isPagingDisplay:true,
            pt115Init: {
                productList: [],
                colorTitle:'',
                sizeTitle:'',
                categoryNmOptionFlg: 0,
                productSortKbnList: [],
                isDisplaySortFlg: false,
            },
            pt115ReqModel: {
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 16,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1,
                pointFlg: 0
            },
            isModalShow:false,
            msgConfirm:'',
            common:common,
            queryData:null,
            paramsData:null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 16,
                pageNo: 1
            },
            dispPageSizeList:[],
            SiteConstants: SiteConstants,
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            showFlg:false,
            site: "",
            cartShowFlg:false,
            favourireShowFlg:false,
            favouriteAddFlg:[],
            colorSizeFlg : false,
            colorSizeModal:{
                colSizList : [],
                csitemimg : "",
                colorTitle:'',
                sizeTitle:'',
            },
            dataColorSize:{},
            colorSizeQty : 0,
            colorSizeTnk : 0,
            colorSizeItemNm : "",
            selectedSortNo : this.ptOrderByType,
            showPassModal: false,
            warningMsg: ''
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt115Init = _this.ptInitData;
           
            _this.$nextTick(() => {
                let robots = document.querySelector('meta[name="robots"]');
                if(_this.pt115Init.accessDialogFlg == 1) {
                    //シークレットでパスワード入力させるカテゴリの時、検索対象外<meta name="robots" content="noindex,nofollow" />とする
                    if (robots){
                        robots.setAttribute("content","noindex,nofollow");
                    }else{
                        robots = document.createElement("meta");
                        robots.setAttribute("name","robots");
                        robots.setAttribute("content","noindex,nofollow");
                        document.head.appendChild(robots);
                    }

                }else{
                    if (robots){
                        document.head.removeChild(robots);
                    }
                    //<title>タグで「カテゴリ名 | サイト名」とする※既存ではサイト名のみ
                    if (_this.pt115Init.categoryNm){
                        document.title = _this.pt115Init.categoryNm + " | " + _this.pt115Init.siteNm;
                    }else{
                        document.title =_this.pt115Init.siteNm;
                    }
                    
                    //<meta property="og:title">タグでcontentをカテゴリ名とする
                    let ogTitle = document.querySelector('meta[property="og:title"]');
                    if (ogTitle){
                        if (_this.pt115Init.categoryNm){
                            ogTitle.setAttribute("content", _this.pt115Init.categoryNm);
                        }
                    }
                    //<meta property="og:site_name">タグでcontentをサイト名とする
                    let ogSiteName = document.querySelector('meta[property="og:site_name"]');
                    if (ogSiteName) {
                        ogSiteName.setAttribute("content", _this.pt115Init.siteNm);
                    }
                    //<meta keywords>に「カテゴリ名,」を先頭に追加する
                    let keywords = document.querySelector('meta[name="keywords"]');
                    if (keywords) {
                        let keywordsText = keywords.getAttribute("content");
                        if (_this.pt115Init.categoryNm){
                            if (keywordsText){
                                keywords.setAttribute("content", _this.pt115Init.categoryNm + "," + keywordsText);
                            }else{
                                keywords.setAttribute("content", _this.pt115Init.categoryNm);
                            }
                        }else{
                            keywords.setAttribute("content", keywordsText);
                        }
                    }
                }                
            });

            if(_this.pt115Init.accessDialogFlg == 1) {
                _this.showPassModal = true;
                return;
            }

            // カートに入れるボタン表示オプション 0:表示しない 1:表示する
            if (_this.pt115Init.cartButtonFlg == 1) {
                _this.cartShowFlg = true;
            }
            // お気に入りボタン表示オプション 0:表示しない 1:表示する
            if (_this.pt115Init.favouriteButtonFlg == 1) {
                _this.favourireShowFlg = true;
            }
            if(_this.ptInitData.productList != null){

                _this.pageFeedData.totalRecord = _this.ptInitData.totalRecord;
                _this.pageFeedData.fromRecord = _this.ptInitData.fromRecord;
                _this.pageFeedData.toRecord = _this.ptInitData.toRecord;
                _this.pageFeedData.pageSize = _this.ptInitData.pageSize;
                _this.pageFeedData.pageNo = _this.ptInitData.pageNo;
                if(_this.ptInitData.productList.length > 0){
                    _this.isPagingDisplay = true;
                }else{
                    _this.isPagingDisplay = false;
                }
                // お気に入りボタンの初期値設定
                for (var i = 0; i < _this.pt115Init.productList.length; i++) {
                    if (_this.pt115Init.productList[i].OKINI_ITEM_CD == "0") {
                        _this.favouriteAddFlg[i] = true;
                    } else {
                        _this.favouriteAddFlg[i] = false;
                    }
                }
            }
            if (_this.pt115Init.productSortKbnList != null && _this.pt115Init.productSortKbnList.length > 0) {
                // 表示順のデフォルト値
                _this.selectedSortNo = _this.ptInitData.reqModel.selectedSortNo;
                _this.pt115Init.isDisplaySortFlg = true;
            } else {
                _this.pt115Init.isDisplaySortFlg = false;
            }
            _this.dispPageSizeList = _this.pt115Init.pageSizeList;

            _this.pt115ReqModel = Object.assign({}, _this.pt115ReqModel, _this.ptInitData.reqModel);
            _this.showFlg = true;
        }else{
            _this.doInit();
        }

        //close pupup
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
            _this.colorSizeFlg = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        doInit() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT115 + _this.$UrlConstants.DO_INIT, _this.pt115ReqModel).then(function(response) {
                _this.pt115Init = response.data;
                if(_this.pt115Init.accessDialogFlg == 1) {
                    _this.pt115ReqModel.secretPassword = '';
                    // シークレットパスワードが違います。
                    _this.warningMsg = _this.$i18n.t('pt115.labels.passwordError');
                    _this.showPassModal = true;
                    return;
                }

                // カートに入れるボタン表示オプション 0:表示しない 1:表示する
                if (_this.pt115Init.cartButtonFlg == 1) {
                    _this.cartShowFlg = true;
                }
                // お気に入りボタン表示オプション 0:表示しない 1:表示する
                if (_this.pt115Init.favouriteButtonFlg == 1) {
                    _this.favourireShowFlg = true;
                }
                if(response.data.productList != null){
                    _this.pageFeedData.totalRecord = response.data.totalRecord;
                    _this.pageFeedData.fromRecord = response.data.fromRecord;
                    _this.pageFeedData.toRecord = response.data.toRecord;
                    _this.pageFeedData.pageSize = response.data.pageSize;
                    _this.pageFeedData.pageNo = response.data.pageNo;
                    if(response.data.productList.length > 0){
                        _this.isPagingDisplay = true;
                    }else{
                        _this.isPagingDisplay = false;
                    }
                    // お気に入りボタンの初期値設定
                    for (var i = 0; i < _this.pt115Init.productList.length; i++) {
                        if (_this.pt115Init.productList[i].OKINI_ITEM_CD == "0") {
                            _this.favouriteAddFlg[i] = true;
                        } else {
                            _this.favouriteAddFlg[i] = false;
                        }
                    }
                }
                if (_this.pt115Init.productSortKbnList != null && _this.pt115Init.productSortKbnList.length > 0) {
                    _this.pt115Init.isDisplaySortFlg = true;
                } else {
                    _this.pt115Init.isDisplaySortFlg = false;
                }
                _this.dispPageSizeList = _this.pt115Init.pageSizeList;

                _this.pt115ReqModel = Object.assign({}, _this.pt115ReqModel, response.data.reqModel);
                _this.showFlg = true;
            }).catch(function(error) {
                common.errorAPI(error);
            });

        },

        okAction(evt) {
            this.warningMsg = '';
            if(this.pt115ReqModel.secretPassword) {
                this.doInit();
            } else {
                evt.preventDefault();
                this.warningMsg = this.$i18n.t('pt115.labels.passwordInput');
            }
        },

        icon_flg1: function(product){
            if(product.ITEM_STATUS1 == '0'){
                return product.ICON_NM1;
            } else {
                return "";
            }
        },
        icon_flg2: function(product){
            if(product.ITEM_STATUS2 == '0'){
                return product.ICON_NM2;
            } else {
                return "";
            }
        },
        icon_flg3: function(product){
            if(product.ITEM_STATUS3 == '0'){
                return product.ICON_NM3;
            } else {
                return "";
            }
        },
        evtChangeCategory: function() {
            this.pt115ReqModel.categoryCd = this.categoryCd;
            this.reSearch();
        },
        evtChangeSearch: function() {
            this.pt115ReqModel.itemNm = this.searchNm;
            this.reSearch();
        },
        /*
        * 商品詳細画面へ遷移
        */
        doDetail: function(sItemNo){
            var _this = this;
            var categoryCd = _this.pt115ReqModel.categoryCd;
            var ptPageNo = _this.pt115ReqModel.pageNo;
            var ptPageSize = _this.pt115ReqModel.pageSize;
            var searchItemNm = _this.pt115ReqModel.itemNm;
            var itemNmOnly = _this.pt115ReqModel.itemNmOnly;
            var priceS = _this.pt115ReqModel.priceS;
            var priceE = _this.pt115ReqModel.priceE;
            var pointFlg = _this.pt115ReqModel.pointFlg;

            _this.$emit("event-loading", true);
            _this.$router.push({ name: SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo, categoryCd: categoryCd
                                ,ptPageNo: ptPageNo,ptPageSize: ptPageSize, searchItemNm: searchItemNm
                                ,itemNmOnly: itemNmOnly,priceS: priceS, priceE: priceE,pointFlg: pointFlg}});
        },
        goDetail: function(sItemNo){
            if (window.event.target.tagName != 'BUTTON' && window.event.target.tagName != 'INPUT'){
                this.doDetail(sItemNo);
            }else{
                return false;
            }
            return true;
        },
        /*
        * 注文処理
        */
        doOrder : function (ItemData) {
            var _this = this;
            var itemCnt = 0;
            var sitemNos = [];
            var qtys = [];
            // 数量が入力されていない場合はエラー
            for (var i = 0; i < ItemData.length; i++) {
                if (ItemData[i].QTY >= 1) {
                    qtys[i] = ItemData[i].QTY;
                    sitemNos[i] = ItemData[i].S_ITEM_CD;
                    itemCnt = itemCnt + 1;
                }
            }
            if(itemCnt == 0){
                _this.msgConfirm = _this.$i18n.t('pt115.labels.messenge')
                _this.isModalShow = true;
                return;
            }
            var reqModel = {};
            reqModel.sitemNos = sitemNos;
            reqModel.qtys = qtys;

            _this.$emit("event-loading", true);
            // カート追加処理
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT115 + _this.$UrlConstants.DO_ORDER, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.msgConfirm = _this.$i18n.t("pt115.labels.Order");
                    toastr.success(_this.msgConfirm);
                    _this.$emit('evt-change-quantily');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, 'pt115');
                            if(resultValid){
                                if (resultValid.mapMsg[0].key == "count") {
                                    _this.msgConfirm = resultValid.mapMsg[0].mess;
                                } else {
                                    _this.msgConfirm = ItemData.webItemName +"は"+ resultValid.mapMsg[0].mess;
                                }
                                
                                _this.isModalShow = true;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * まとめ買い割引詳細画面へ
        */
        showMatomeDetail: function(product){
            var _this = this;
            var matomeCd = product.MATOME_CD;
            _this.$emit("event-loading", true);
            var ptPageNo = _this.pt115ReqModel.pageNo;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 27},params: {matomeCd:matomeCd,backPageNo:ptPageNo} });
        },
        /*
        * カラーサイズ商品コードセット
        */
        setValue(data){
            var _this = this;
            var prdReq = {};
            prdReq.ordSItemNo = data.sItemNo;
            prdReq.qty = _this.colorSizeQty;
            prdReq.tnk = _this.colorSizeTnk;
            prdReq.webItemName = _this.colorSizeItemNm;
            _this.doOrder(prdReq);
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt115ReqModel.pageSize = pageSize;
            this.pt115ReqModel.pageNo = pageNo;
            this.pt115ReqModel.orderByType = sortNo;
            this.reSearch();
        },
        changePageSize: function(pageSize) {
            this.pt115ReqModel.pageSize = pageSize;
            this.reSearch();
        },
        changePageNo: function(pageNo) {
            this.pt115ReqModel.pageNo = pageNo;
            var queryString = this.getQueryString(pageNo, 'ptPageNo');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        changeDispSortNo: function(sortNo) {
            this.pt115ReqModel.orderByType = sortNo;
            var queryString = this.getQueryString(sortNo, 'ptOrderByType');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        // 再検索処理
        reSearch: function() {
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT115 + _this.$UrlConstants.DO_INIT, _this.pt115ReqModel).then(function(response) {
                _this.pt115Init = response.data;
                _this.pageFeedData.totalRecord = response.data.totalRecord;
                _this.pageFeedData.fromRecord = response.data.fromRecord;
                _this.pageFeedData.toRecord = response.data.toRecord;
                _this.pageFeedData.pageSize = response.data.pageSize;
                _this.pageFeedData.pageNo = response.data.pageNo;
                common.scrollTop();
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * format number value to currency value
         * @param {number} value, number to format
         */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        getQueryString: function(val, type){
            var query = this.$route.query;

            query.ptPageNo = this.pt115ReqModel.pageNo;
            query.ptPageSize = this.pt115ReqModel.pageSize;
            query.ptOrderByType = this.pt115ReqModel.orderByType;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else if (query[propertyName] != null){
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /* 
        * Function nvl for string item 
        */
        stringNvl: function(item, def){
            if(item == null || item == undefined){
                return def;
            }
            return item;
        }
    },
    created(){
        this.queryData = this.$route.query;
        this.paramsData = this.$route.params;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.pt115ReqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.pt115ReqModel.pageSize = this.queryData.ptPageSize;
            }
            if(this.queryData.ptOrderByType != null){
                this.pt115ReqModel.orderByType = this.queryData.ptOrderByType;
            }
            if(this.paramsData.searchItemNm != null){
                this.pt115ReqModel.itemNm = this.paramsData.searchItemNm;
            }
            if(this.queryData.searchItemNm != null){
                this.pt115ReqModel.itemNm = this.queryData.searchItemNm;
            }
            if(this.paramsData.categoryCd != null){
                this.pt115ReqModel.categoryCd = this.paramsData.categoryCd;
            }
            if(this.queryData.categoryCd != null){
                this.pt115ReqModel.categoryCd = this.queryData.categoryCd;
            }
            if(this.queryData.itemNmOnly != null){
                this.pt115ReqModel.itemNmOnly = this.queryData.itemNmOnly;
            }
            if(this.queryData.priceS != null){
                this.pt115ReqModel.priceS = this.queryData.priceS;
            }
            if(this.queryData.priceE != null){
                this.pt115ReqModel.priceE = this.queryData.priceE;
            }
            if(this.queryData.pointFlg != null){
                this.pt115ReqModel.pointFlg = this.queryData.pointFlg;
            }
        }
    },
    watch: {
        evtChangeCategoryFlg() {
            this.evtChangeCategory();
        },
        evtChangeSearchFlg() {
            this.evtChangeSearch();
        }
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    }
}
</script>
